__webpack_require__.p = "https://ikea.marat.qd.je/cz/cs/customer-service/support/";